import { toast } from "react-toastify";
import { useApi } from "../../../../hooks/useApi";
import Flex from "../../../DefaultStyles/Flex";
import Loader from "../../../DefaultStyles/Loader";
import DefaultModalLayout from "../../../Modal/DefaultModalLayout";
import { DefaultModalCommonProps } from "../../Users/UserDetail/CommentModal/CommentModal";
import { ModalLabel } from "../../Users/UserDetail/CommentModal/TargetContainer";
import styled from "styled-components";
import React, { useEffect } from "react";
import { useRecoilValue } from "recoil";
import { authType } from "../../../../pages/Login";
import { DefaultBox } from "./UplusCodeDownloadModal";
import dayjs from "dayjs";
import Blank from "../../../DefaultStyles/Blank";

interface UplusCodeLogModalProps extends DefaultModalCommonProps {
  code: string;
}

export default function UplusCodeLogModal({
  closeEvent,
  confirmEvent,
  code,
}: UplusCodeLogModalProps) {
  const auth = useRecoilValue(authType);

  const { response, loading, error } = useApi({
    method: "get",
    url: auth?.uplus && code?.length > 0 ? `uplus2/log/${code}` : undefined,
  });

  useEffect(() => {
    if (response?.status === 200 && response?.data?.list?.length === 0) {
      toast.error("로그를 확인할 수 없습니다.");
    }
  }, [response]);

  useEffect(() => {
    if (error) {
      toast.error(error?.data ?? "로그 확인에 실패하였습니다.");
    }
  }, [error]);

  return (
    <>
      <DefaultModalLayout
        modalTitle="로그 확인"
        cancelBtn={<></>}
        closeEvent={() => closeEvent()}
        confirmEvent={() => closeEvent()}
        isMediumModal={true}
        leftBottomName={
          response?.data?.list[response?.data?.list?.length - 1]?.updater
        }
        leftBottomTime={
          response?.data?.list[response?.data?.list?.length - 1]?.date
        }
      >
        {response?.data?.list?.length > 0 && (
          <Flex gapSize={12}>
            <Column>
              <ModalLabel>내용</ModalLabel>
            </Column>

            <ModalLabel>로그 시간</ModalLabel>
          </Flex>
        )}

        {response?.data?.list?.map(
          (l: {
            id: string;
            code: string;
            comment: string;
            updater: string;
            date: string;
          }) => (
            <Row key={l?.id}>
              <Flex gapSize={12}>
                <Column>
                  <DefaultBox>{l?.comment}</DefaultBox>
                </Column>

                <DefaultBox style={{ width: "calc(100% - 250px - 12px)" }}>
                  {dayjs(l?.date).format("YYYY-MM-DD HH:mm")}
                </DefaultBox>
              </Flex>
            </Row>
          )
        )}

        <Blank marginHeight={20} blankHeight={20} />
      </DefaultModalLayout>

      {loading && <Loader />}
    </>
  );
}

const Column = styled.div`
  width: 250px;
`;

const Row = styled.div`
  width: 100%;

  &:not(:last-child) {
    margin-bottom: 8px;
  }
`;
